document.querySelector(".cookie__close").onclick = () => {
  document.querySelector(".cookie__inner").classList.add("hidden");
  document.cookie = "modal=false";
};

document.querySelector(".cookie__button").onclick = () => {
  document.querySelector(".cookie__inner").classList.add("hidden");
  document.cookie = "modal=false";
};

function get_cookie(cookie_name) {
  var results = document.cookie.match(
    "(^|;) ?" + cookie_name + "=([^;]*)(;|$)"
  );

  if (results) return unescape(results[2]);
  else return null;
}

var value = get_cookie("modal");

if (value === "false") {
  document.querySelector(".cookie__inner").classList.add("hidden");
}
